import PropTypes from 'prop-types'
import { Popover } from 'react-bootstrap'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import { randomId } from 'utils'
import Btn from './buttons/Btn'

/**
 * Simplification over Tooltip + OverlayTrigger implementations. Can be user either raw, to add a tooltip over any
 * element, or with a question mark via {@see Tip.Bubble}.
 * @param text
 * @param children
 * @param forDisabled {boolean} If The wrapping element is disabled, this must be set to true for the trigger to work.
 * @param popover {boolean} Use it only when the user needs to interact with the contents - e.g. click a link. TODO: add a popover title for even more complex popovers
 * @param placement {'auto-start'|'auto'|'auto-end'|'top-start'|'top'|'top-end'|'right-start'|'right'|'right-end'|'bottom-end'|'bottom'|'bottom-start'|'left-end'|'left'|'left-start'}
 * @return {JSX.Element}
 * @constructor
 */
export default function Tip({ text, children, forDisabled = false, popover = false, placement = 'auto' }) {
	const id = randomId('tooltip')
	const overlay = popover?
		<Popover id={id}><Popover.Content>{text}</Popover.Content></Popover> :
		<Tooltip id={id}>{text}</Tooltip>

	// noinspection JSValidateTypes
	return <OverlayTrigger {...{ overlay, placement }} trigger={popover? 'click' : ['hover', 'focus']}>
		{forDisabled? <span className="tooltip-overlay-trigger">{children}</span> : children}
	</OverlayTrigger>
}

Tip.Bubble = function ({ children, text = '', popover = false, className = '', placement = 'auto', sm = false, xs = false }) {
	return <Tip text={text || children} {...{ placement, popover }}>
		<Btn icon="question-circle" variant="link" iconSize={xs? 'sm' : sm? '1x' : 'lg'}
		     className={`px-2 text-muted ${className}`}/>
	</Tip>
}

const PlacementPropType = PropTypes.oneOf(['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'])

Tip.propTypes = {
	text     : PropTypes.node,
	popover  : PropTypes.bool,
	placement: PlacementPropType,
}

Tip.Bubble.propTypes = {
	sm       : PropTypes.bool,
	xs       : PropTypes.bool,
	popover  : PropTypes.bool,
	placement: PlacementPropType,
	className: PropTypes.string,
	text     : PropTypes.string //either text or children
}
